module.exports = __webpack_public_path__ + "img/分组 10.785e9f45.png";